// src/componants/common/BrandIdentity.js
import { useState } from "react";
import { useBrand } from "../../context/BrandContext";
import "./BrandIdentity.css";

/**
 * Shared "who is this company" widget: real brand logo when one exists,
 * always falling back to the short ESS-style badge if there is no
 * brand-logo.png (or it fails to load) — same pattern already used on
 * LoginPage. Optionally renders the full company name next to it.
 *
 * Reads brand data from useBrand() (src/context/BrandContext.js), the
 * unified brand data source. Every value falls open to the current ESS
 * look (shortName defaults to "ESS", companyName defaults to
 * "ESS HRMS"), so this is a value-source swap only — nothing changes
 * visually unless a brand build (or, later, a runtime manifest) actually
 * supplies different values.
 *
 * Props let each call site reuse its own existing CSS classes (e.g.
 * "login-logo" / "login-logo-img") instead of introducing new visual
 * language everywhere this is used.
 */
function BrandIdentity({
  showLogo = true,
  showName = true,
  wrapperClassName = "",
  logoClassName = "brand-identity-logo",
  fallbackClassName = "brand-identity-fallback",
  nameClassName = "brand-identity-name",
}) {
  const [logoFailed, setLogoFailed] = useState(false);
  const brand = useBrand();

  return (
    <span className={`brand-identity ${wrapperClassName}`.trim()}>
      {showLogo &&
        (!logoFailed ? (
          <img
            src={brand.logoPath}
            alt={brand.companyName}
            className={logoClassName}
            onError={() => setLogoFailed(true)}
          />
        ) : (
          <span className={fallbackClassName}>{brand.shortName}</span>
        ))}
      {showName && <span className={nameClassName}>{brand.companyName}</span>}
    </span>
  );
}

export default BrandIdentity;
